/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Close the cart drawer when the continue shopping button is clicked
  const continueShoppingBtn = document.querySelector('.continue-shopping--btn');
  if (continueShoppingBtn) {
    continueShoppingBtn.addEventListener('click', function(e) {
      e.preventDefault();
      const cartDrawerCloseBtn = document.querySelector('.cart-block--top .drawer__close');
      if (cartDrawerCloseBtn) {
        cartDrawerCloseBtn.click();
      }
    });
  }

  /* Adjust the savings label padding and the price loaders to match the subtotal price width */

  adjustCartPriceElements(); 

  document.addEventListener('theme:cart:change', function() {
    adjustCartPriceElements(); 
  });

  function adjustCartPriceElements() {
    const cartSubtotal = document.querySelector('.cart__total--subtotal');
    const cartSavings = document.querySelector('.cart__total--savings');

    // Helper function to adjust price loader width
    const adjustPriceLoader = (container) => {
      const price = container?.querySelector('.cart__total__price');
      const loader = container?.querySelector('.cart__price__loader');
      if (price && loader) {
        loader.style.width = `${price.offsetWidth}px`;
      }
    };

    // Adjust savings label padding if both elements exist
    if (cartSubtotal && cartSavings) {
      const subtotalPrice = cartSubtotal.querySelector('.cart__total__price');
      const savingsPrice = cartSavings.querySelector('.cart__total__price'); 
      const savingsLabel = cartSavings.querySelector('.cart__total__label');

      if (subtotalPrice && savingsPrice && savingsLabel) {
        const currentPadding = parseInt(getComputedStyle(savingsLabel).paddingRight);
        const widthDiff = subtotalPrice.offsetWidth - savingsPrice.offsetWidth;
        savingsLabel.style.paddingRight = `${currentPadding + widthDiff}px`;
      }
    }

    // Adjust price loaders
    adjustPriceLoader(cartSubtotal);
    adjustPriceLoader(cartSavings);
  }

  /* PDP: Hide the swatch group title if there are no visible children */

  function updateSwatchGroupVisibility() {
    document.querySelectorAll('[data-swatch-group-options]').forEach(group => {
      const visibleChildren = Array.from(group.children).some(child => {
        return window.getComputedStyle(child).display !== 'none'
      }
      );
      const title = group.parentElement.querySelector('.swatch-group__title');
      if (title) {
        title.style.display = visibleChildren ? '' : 'none';
      }
    });
  }

  // Call initially and whenever variant options change
  const productSection = document.querySelector('.index-product[data-section-type="product"]');
  if (productSection) {
    updateSwatchGroupVisibility();
    productSection.addEventListener('theme:variant:update', updateSwatchGroupVisibility);
  }

  /* Initialize image zoom */

  if (typeof $ !== 'undefined') {
    const zoomImgs = document.querySelectorAll('.jq-zoom-img');
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    // Prevent default zoom behavior
    const productPhotos = document.querySelectorAll('.product__photo');
    productPhotos.forEach(photo => {
      photo.addEventListener('gesturestart', function(e) {
        e.preventDefault();
      }, { passive: false });
      
      photo.addEventListener('gesturechange', function(e) {
        e.preventDefault();
      }, { passive: false });
    });

    Array.from(zoomImgs).map(img => {
      if (isTouchDevice) {
        const photoContainer = img.closest('.product__photo');
        let currentScale = 1;
        let startDistance = 0;
        let initialScale = 1;
        let translateX = 0;
        let translateY = 0;
        let lastMidpointX = 0;
        let lastMidpointY = 0;
        let lastTouchX = 0;
        let lastTouchY = 0;
        let wasZooming = false;
        let zoomTimeout = null;

        // Preload high-res image
        const highResUrl = img.getAttribute('data-jq-zoom');
        if (highResUrl) {
          const highResImg = new Image();
          highResImg.onload = function() {
            // Replace original image source with high-res version
            img.src = highResUrl;
            
            // Update srcset to empty to ensure high-res image is used
            img.srcset = '';
          };
          highResImg.src = highResUrl;
        }

        function constrainTranslation() {
          // Get container dimensions
          const containerRect = photoContainer.getBoundingClientRect();
          
          // Calculate separate constraints for width and height
          const maxTranslateY = containerRect.height * (currentScale - 1) / 2;
          const maxTranslateX = containerRect.width * (currentScale - 1) / 2;
          
          translateX = Math.min(maxTranslateX, Math.max(-maxTranslateX, translateX));
          translateY = Math.min(maxTranslateY, Math.max(-maxTranslateY, translateY));
        }

        photoContainer.addEventListener('touchstart', function(e) {
          if (e.touches.length === 2) {
            e.preventDefault();
            wasZooming = true;
            startDistance = getDistance(e.touches[0], e.touches[1]);
            initialScale = currentScale;
            
            const midpoint = getMidpoint(e.touches[0], e.touches[1]);
            lastMidpointX = midpoint.x;
            lastMidpointY = midpoint.y;
          } else if (e.touches.length === 1 && currentScale > 1) {
            e.preventDefault();
            if (!wasZooming) {
              lastTouchX = e.touches[0].clientX;
              lastTouchY = e.touches[0].clientY;
            }
          }
        }, { passive: false });

        photoContainer.addEventListener('touchmove', function(e) {
          if (e.touches.length === 2) {
            e.preventDefault();
            // Clear any existing timeout when we detect two fingers
            if (zoomTimeout) {
              clearTimeout(zoomTimeout);
              zoomTimeout = null;
            }
            
            // Handle pinch zoom
            const distance = getDistance(e.touches[0], e.touches[1]);
            const scale = Math.min(4, Math.max(1, initialScale * (distance / startDistance)));
            currentScale = Math.round(scale * 100) / 100;
            
            const midpoint = getMidpoint(e.touches[0], e.touches[1]);
            const deltaX = midpoint.x - lastMidpointX;
            const deltaY = midpoint.y - lastMidpointY;
            
            translateX += deltaX;
            translateY += deltaY;
            
            lastMidpointX = midpoint.x;
            lastMidpointY = midpoint.y;
            
            constrainTranslation();
            updateTransform();
          } else if (e.touches.length === 1 && currentScale > 1 && !wasZooming) {
            e.preventDefault();
            // Only handle panning if we weren't just zooming
            const touch = e.touches[0];
            const deltaX = touch.clientX - lastTouchX;
            const deltaY = touch.clientY - lastTouchY;
            
            translateX += deltaX;
            translateY += deltaY;
            
            lastTouchX = touch.clientX;
            lastTouchY = touch.clientY;
            
            constrainTranslation();
            updateTransform();
          }
        }, { passive: false });

        photoContainer.addEventListener('touchend', function(e) {
          if (e.touches.length < 2) {
            if (currentScale < 1.1) {
              currentScale = 1;
              translateX = 0;
              translateY = 0;
              updateTransform();
            } else {
              constrainTranslation();
              updateTransform();
            }
            
            // Set a timeout before allowing single-finger panning
            if (wasZooming) {
              if (zoomTimeout) {
                clearTimeout(zoomTimeout);
              }
              zoomTimeout = setTimeout(() => {
                wasZooming = false;
                zoomTimeout = null;
              }, 100); // 100ms delay
            }
          }
        });

        function updateTransform() {
          img.style.transform = `scale(${currentScale}) translate(${translateX/currentScale}px, ${translateY/currentScale}px)`;
          img.style.transformOrigin = 'center';
        }

        function getDistance(touch1, touch2) {
          const dx = touch1.clientX - touch2.clientX;
          const dy = touch1.clientY - touch2.clientY;
          return Math.sqrt(dx * dx + dy * dy);
        }

        function getMidpoint(touch1, touch2) {
          return {
            x: (touch1.clientX + touch2.clientX) / 2,
            y: (touch1.clientY + touch2.clientY) / 2
          };
        }
      } else {
        // Use jQuery zoom for desktop
        $(img.parentElement).zoom({
          touch: false,
          url: img.getAttribute('data-jq-zoom'),
          on: 'mouseover'
        });
      }
    });
  }

  /* Scroll to products grid if collection page has filters */

  const collectionNav = document.querySelector('[data-collection-nav]');
  const productsGrid = document.querySelector('[data-products-grid]');
  if (collectionNav && productsGrid && window.location.search.includes('filter.')) {
    window.theme.methods.scrollTo(productsGrid.getBoundingClientRect().top - collectionNav.offsetHeight);
  }

  /* Sync related products' variant images with the main product's selected color */

  function syncRelatedProductsVariants() {
    const relatedSection = document.querySelector('[data-related-section]');
    
    if (!productSection || !relatedSection) return;

    // Get the currently selected color from the main product
    const selectedColorInput = productSection.querySelector('input[data-index="option1"]:checked');
    if (!selectedColorInput) return;
    const selectedColor = selectedColorInput.value;

    // Find all product items in the grid slider
    const gridSlider = relatedSection.querySelector('.grid--slider');
    if (!gridSlider) return;

    const relatedProducts = Array.from(gridSlider.children);
    relatedProducts.forEach((product) => {
      // Find the grid swatch element and matching swatch button
      const gridSwatch = product.querySelector('grid-swatch');
      const swatchLink = product.querySelector(`.swatch__link[data-swatch="${selectedColor}"]`);
      const matchingSwatch = swatchLink?.closest('.swatch__button');
      
      if (!gridSwatch || !matchingSwatch) return;

      // Get the variant title from the swatch button
      const variantTitle = matchingSwatch.getAttribute('data-swatch-variant-name');
      if (!variantTitle) return;

      // Find the variant image
      const variantImage = product.querySelector(`[data-variant-title="${variantTitle}"]`);
      if (!variantImage) return;

      // Get the default image container and its featured image
      const defaultImageContainer = product.querySelector('[data-product-image-default]');
      if (!defaultImageContainer) return;

      // Replace the featured image with the variant image
      const featuredImage = defaultImageContainer.querySelector('img');
      const variantImg = variantImage.querySelector('img');
      if (featuredImage && variantImg) {
        Array.from(variantImg.attributes).forEach(attr => {
          featuredImage.setAttribute(attr.name, attr.value);
        });
      }

      // Update the product links to match the variant
      const variantUrl = swatchLink.href;
      const productLinks = product.querySelectorAll('a.product-link');
      productLinks.forEach(link => {
        link.href = variantUrl;
        link.setAttribute('data-product-link', variantUrl);
      });

    });
  }

  // Run when related products are loaded and when variants change
  if (productSection) {
    const relatedSection = document.querySelector('[data-related-section]');
    if (relatedSection) {
      // Watch for related products being added to the DOM
      const observer = new MutationObserver((mutations, obs) => {
        const gridSlider = relatedSection.querySelector('.grid--slider');
        if (gridSlider) {
          const productItems = gridSlider.children;
          if (productItems.length > 0) {
            // Watch for grid-swatch elements being populated
            const swatchObserver = new MutationObserver((mutations) => {
              // Only process mutations that added nodes
              const relevantMutations = mutations.filter(mutation => 
                mutation.type === 'childList' && mutation.addedNodes.length > 0
              );
              
              if (relevantMutations.length === 0) return;
              
              // Check if all grid-swatches have their buttons
              const gridSwatches = gridSlider.querySelectorAll('grid-swatch');
              const allInitialized = Array.from(gridSwatches).every(swatch => 
                swatch.querySelector('.swatch__button')
              );
              
              if (allInitialized) {
                swatchObserver.disconnect();
                obs.disconnect();
                syncRelatedProductsVariants();
              }
            });
            
            // Observe the grid-swatch elements
            const gridSwatches = gridSlider.querySelectorAll('grid-swatch');
            gridSwatches.forEach(swatch => {
              swatchObserver.observe(swatch, {
                childList: true,
                subtree: true
              });
            });
            
            // Disconnect the main observer since we found our products
            obs.disconnect();
          }
        }
      });

      observer.observe(relatedSection, {
        childList: true,
        subtree: true
      });

      // Update when variants change
      productSection.addEventListener('theme:variant:change', syncRelatedProductsVariants);
    }
  }

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
document.addEventListener('DOMContentLoaded', function () {
  function getSelectedVariant(container, productData) {
    const checkedOptions = container.querySelectorAll('[data-single-option-selector]:checked');
    const selectedValues = Array.from(checkedOptions).map(function (input) {
      return input.value;
    });

    if (!selectedValues.length) return null;

    return productData.variants.find(function (variant) {
      if (!variant.options || variant.options.length !== selectedValues.length) return false;

      return variant.options.every(function (optionValue, index) {
        return optionValue === selectedValues[index];
      });
    }) || null;
  }
function updateCustomSaleBanner(container) {
  const banner = container.querySelector('[data-custom-sale-banner]');
  const productJsonEl = container.querySelector('[data-product-json]');
  const detailEl = container.querySelector('[data-custom-sale-detail]');
  const bulkNote = container.querySelector('.product__bulk-note');
  const topPriceEl = container.querySelector('[data-top-price]');
  const livePriceEl = container.querySelector('[data-product-price]');

  if (!productJsonEl) return;

  let productData;
  try {
    productData = JSON.parse(productJsonEl.textContent);
  } catch (e) {
    return;
  }

  const selectedVariant = getSelectedVariant(container, productData);
  const isOnSale =
    selectedVariant &&
    selectedVariant.compare_at_price &&
    selectedVariant.compare_at_price > selectedVariant.price;

  if (bulkNote) {
    if (!bulkNote.dataset.defaultBulkNote) {
      bulkNote.dataset.defaultBulkNote = bulkNote.innerHTML;
    }

    const defaultBulkNote = bulkNote.dataset.defaultBulkNote;
    const saleBulkNote = bulkNote.dataset.saleBulkNote || defaultBulkNote;

    bulkNote.innerHTML = isOnSale ? saleBulkNote : defaultBulkNote;
  }

  if (topPriceEl) {
      if (isOnSale) {
        var formattedCompare = (selectedVariant.compare_at_price / 100).toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD'
        });
        var formattedPrice = (selectedVariant.price / 100).toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD'
        });
        topPriceEl.innerHTML = '<s>' + formattedCompare + '</s> <span style="color: #c0392b;">' + formattedPrice + '</span>';
      } else if (livePriceEl) {
        topPriceEl.textContent = livePriceEl.textContent.trim();
      }
    }

  if (!banner) return;

  if (isOnSale) {
    const discount = Math.round(
      ((selectedVariant.compare_at_price - selectedVariant.price) / selectedVariant.compare_at_price) * 100
    );

    const formattedSalePrice = (selectedVariant.price / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });

    if (detailEl) {
      detailEl.textContent = `Now ${formattedSalePrice} – ${discount}% off this combo`;
    }

    banner.classList.remove('hidden');
  } else {
    if (detailEl) {
      detailEl.textContent = '';
    }

    banner.classList.add('hidden');
  }
}

  function initCustomSaleBanners() {
    const productContainers = document.querySelectorAll('[data-product], [data-section-type]');

    productContainers.forEach(function (container) {
      if (!container.querySelector('[data-custom-sale-banner]')) return;

      updateCustomSaleBanner(container);

      container.addEventListener('change', function () {
        setTimeout(function () {
          updateCustomSaleBanner(container);
        }, 100);
      });

      container.addEventListener('click', function () {
        setTimeout(function () {
          updateCustomSaleBanner(container);
        }, 100);
      });
    });
  }

  initCustomSaleBanners();
});